import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SegmentService from './SegmentService';

export default function useSegmentPage() {
    const location = useLocation();

    useEffect(() => {
        SegmentService.page(location);
    }, [location]);
}
